
import React from "react";
import PropTypes from "prop-types";
import { mainTable } from "../css/Common";

const RadioGroup = (props) => {
  const selectedOption = props.selectedOptions ?? '';

  const handleOptionChange = (value) => {
    props.controlFunc(value);
  };

  return (
    <div className={props.classDiv || "form-group"}>
      <label className={props.classLabel ? props.classLabel : mainTable.label}>
        {props.title}
        <span className={props.classStar ? props.classStar : "hidden"}>*</span>
      </label>

      <div className={props.Class1 || mainTable.inputRadioDiv}>
        {props.options.map((option) => (
          <label
            key={option.value}
            className={props.ClassLabel || mainTable.inputRadioLabel}
          >
            <input
              className={props.Class || mainTable.inputRadio}
              name={props.setName}
              onChange={() => handleOptionChange(option.value)}
              value={option.value}
              checked={String(selectedOption) === String(option.value)}
              type="radio"
              disabled={props.disabled}
              tabIndex={props.tabIndex}
              onBlur={props.controlFuncBlur}
            />
            {option.label}
          </label>
        ))}
      </div>
      {props.errorMessage && (
        <span className="text-red-500">{props.errorMessage}</span>
      )}
    </div>
  );
};

RadioGroup.propTypes = {
  title: PropTypes.string,
  setName: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedOptions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  controlFunc: PropTypes.func,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  errorMessage: PropTypes.string,
};

export default RadioGroup;